import { useGetConversationStatsQuery } from "@financial-advisory/data-access/financial-advisory-api-service";
import { MessageSquare } from "lucide-react";
import { LoadingMetricCard } from "./LoadingMetricCard";
import { MetricCard } from "./MetricCard";

export const ChatInteractionsMetricCard = () => {
  const { data, isLoading, isFetching } = useGetConversationStatsQuery();

  if (isLoading || isFetching) {
    return <LoadingMetricCard label="Chat interactions" />;
  }

  return (
    <MetricCard
      icon={<MessageSquare className="w-4 h-4" />}
      value={(data?.total_conversations ?? 0).toString()}
      label="Chat interactions"
      className="w-1/3"
    />
  );
};
